/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Core
import Providers from "Providers";
import ReactDOM from "react-dom";

import "./theme/tokens.css";
import "./theme/tailwind.generated.css";
// Variable build (full.css) so the FILL/wght/opsz/GRAD axes are available —
// the static build bakes FILL at 0, leaving icons permanently outlined.
import "@fontsource-variable/material-symbols-rounded/full.css";

// import i18n for locale
import "./i18n";

// Components
import App from "App";

ReactDOM.render(
  <Providers>
    <App />
  </Providers>,
  document.getElementById("root")
);
